import { FilterDropdown } from '@ui';
import { UseFiltersType } from '@/hooks/useFilters';
import { useSearchableList } from '@/hooks/useSearchableList';
import { useCountrySubdivisionInfo } from '@/hooks/useCountrySubdivisionInfo';
import { useCountriesData } from '@/contexts/CountriesDataProvider';

type CountryStatePairFilterProps = Pick<
  UseFiltersType<{ countries: string[]; states: string[] }>,
  'filters' | 'updateFilters'
>;

export const CountryStatePairFilter = ({ filters, updateFilters }: CountryStatePairFilterProps) => {
  const { countriesSelectList, composedSubdivisionsList } = useCountriesData();
  const [country] = filters.countries;
  const statesByCountryList = composedSubdivisionsList[country] || [];
  const { countryHasStates, stateLabel: stateFilterTitle } = useCountrySubdivisionInfo(country);

  const { list: countriesList, setSearchValue: onCountriesSearch } = useSearchableList(countriesSelectList, [
    'name',
    'value',
  ]);

  const { list: statesList, setSearchValue: onStatesSearch } = useSearchableList(statesByCountryList, [
    'name',
    'value',
  ]);

  const onCountryChange = (values: string[]) => {
    updateFilters(values, 'countries');
    updateFilters([], 'states');
  };

  return (
    <>
      <FilterDropdown
        title="Country"
        items={countriesList}
        selectedKeys={filters.countries}
        mode="single"
        onSearchValue={onCountriesSearch}
        onSelectedKeysChange={onCountryChange}
      />
      {countryHasStates && (
        <FilterDropdown
          title={stateFilterTitle}
          items={statesList}
          selectedKeys={filters.states}
          mode="multiple"
          onSearchValue={onStatesSearch}
          onSelectedKeysChange={(values) => updateFilters(values, 'states')}
        />
      )}
    </>
  );
};
